import { useState } from "react";
import { useRecoilState } from "recoil";
import {
  BillStatementModalAtom,
  PayInfoModalStateAtom,
  ServiceBillHisUidAtom,
} from "src/atoms";

// 구매이력에서 사용되는 State
const useBillStatement = () => {
  // const [showBillStatement, setShowBillStatement] = useState<boolean>(false);
  const [billHistory, setBillHistory] = useState<any>([]);
  const [serviceBillHisUid, setServiceBillHisUid] = useRecoilState(
    ServiceBillHisUidAtom
  ); // 결제이력 ID값
  const [showBillStatement, setShowBillStatement] = useRecoilState(
    BillStatementModalAtom
  );
  const [payInfoModalState, setPayInfoModalState] = useRecoilState(
    PayInfoModalStateAtom
  );
  const togglePayInfoModal = ({
    info,
  }: {
    info:
      | "priceType"
      | "licenseCount"
      | "payTerm"
      | "subscriptionCancel"
      | "subscriptionActivate";
  }) => {
    if (info === "priceType") {
      setPayInfoModalState((prev) => ({ ...prev, priceType: !prev.priceType }));
    } else if (info === "licenseCount") {
      setPayInfoModalState((prev) => ({
        ...prev,
        licenseCount: !prev.licenseCount,
      }));
    } else if (info === "payTerm") {
      setPayInfoModalState((prev) => ({ ...prev, payTerm: !prev.payTerm }));
    } else if (info === "subscriptionCancel") {
      setPayInfoModalState((prev) => ({
        ...prev,
        subscriptionsCancel: !prev.subscriptionsCancel,
      }));
    } else if (info === "subscriptionActivate") {
      setPayInfoModalState((prev) => ({
        ...prev,
        subscriptionsActivate: !prev.subscriptionsActivate,
      }));
    }
  };
  const cancelButton = () => {
    setShowBillStatement(false);
  };
  // 청구서 모달 오픈
  const goBillStatement = () => {
    setShowBillStatement(true);
  };
  const goPrint = () => {
    const app: any = document?.getElementById("wrap");
    const modal: any = document.getElementById("billModal");
    const printContents: any = document.querySelector(".modal-body")?.innerHTML;
    const printDiv = document.createElement("DIV");

    document.body.appendChild(printDiv);
    printDiv.innerHTML = printContents;
    app.style.display = "none";
    modal.style.display = "none";

    window.print();

    app.style.display = "block";
    modal.style.display = "block";
    printDiv.style.display = "none";
    printDiv.innerHTML = "";
  };
  return {
    payInfoModalState,
    togglePayInfoModal,
    showBillStatement,
    setShowBillStatement,
    serviceBillHisUid,
    setServiceBillHisUid,
    billHistory,
    setBillHistory,
    cancelButton,
    goPrint,
    goBillStatement,
  };
};

export default useBillStatement;
